import { MedicalPrescription } from "./medical-prescription";
import { MedicalPrescriptionStatus } from "./medical-prescription-status";
import { PaymentMethod } from "./payment-method";

export class ProductItem {
  private ean: string;
  private productName: string;
  private grossPrice: number;
  private price: number;
  private usedNetworkGrossPrice: boolean;
  private usedNetworkNetPrice: boolean;
  private discountValue: number;
  private subsidyValue: number;
  private employmentPayrollValue: number;
  private checkoutValue: number;
  private cardValue: number;
  private beneficiaryValue: number;
  private authorizedQuantity: number;
  private medicalPrescription: MedicalPrescription;
  private medicalPrescriptionStatus: MedicalPrescriptionStatus;
  private errorMessage: string;
  private paymentMethod: PaymentMethod;

  public getEan(): string {
    return this.ean;
  }

  public setEan(value: string): void {
    this.ean = value;
  }

  public getProductName(): string {
    return this.productName;
  }

  public setProductName(value: string): void {
    this.productName = value;
  }

  public getGrossPrice(): number {
    return this.grossPrice;
  }

  public setGrossPrice(value: number): void {
    this.grossPrice = value;
  }

  public getPrice(): number {
    return this.price;
  }

  public setPrice(value: number): void {
    this.price = value;
  }

  public getUsedNetworkGrossPrice(): boolean {
    return this.usedNetworkGrossPrice;
  }

  public setUsedNetworkGrossPrice(value: boolean): void {
    this.usedNetworkGrossPrice = value;
  }

  public getUsedNetworkNetPrice(): boolean {
    return this.usedNetworkNetPrice;
  }

  public setUsedNetworkNetPrice(value: boolean): void {
    this.usedNetworkNetPrice = value;
  }

  public isNetworkSourcePrice(): boolean {
    return this.usedNetworkGrossPrice || this.usedNetworkNetPrice;
  }

  public getDiscountValue(): number {
    return this.discountValue;
  }

  public setDiscountValue(value: number): void {
    this.discountValue = value;
  }

  public getSubsidyValue(): number {
    return this.subsidyValue;
  }

  public setSubsidyValue(value: number): void {
    this.subsidyValue = value;
  }

  public getEmploymentPayrollValue(): number {
    return this.employmentPayrollValue;
  }

  public setEmploymentPayrollValue(value: number): void {
    this.employmentPayrollValue = value;
  }

  public getCheckoutValue(): number {
    return this.checkoutValue;
  }

  public setCheckoutValue(value: number): void {
    this.checkoutValue = value;
  }

  public getCardValue(): number {
    return this.cardValue;
  }

  public setCardValue(value: number): void {
    this.cardValue = value;
  }

  public getBeneficiaryValue(): number {
    return this.beneficiaryValue;
  }

  public setBeneficiaryValue(value: number): void {
    this.beneficiaryValue = value;
  }

  public getAuthorizedQuantity(): number {
    return this.authorizedQuantity;
  }

  public setAuthorizedQuantity(value: number): void {
    this.authorizedQuantity = value;
  }

  public getMedicalPrescription(): MedicalPrescription {
    return this.medicalPrescription;
  }

  public setMedicalPrescription(value: MedicalPrescription): void {
    this.medicalPrescription = value;
  }

  public getMedicalPrescriptionStatus(): MedicalPrescriptionStatus {
    return this.medicalPrescriptionStatus;
  }

  public setMedicalPrescriptionStatus(value: number): void {
    this.medicalPrescriptionStatus = MedicalPrescriptionStatus.fromEnum(value);
  }

  public getErrorMessage(): string {
    return this.errorMessage;
  }

  public setErrorMessage(value: string): void {
    this.errorMessage = value;
  }

  public getPaymentMethod(): PaymentMethod {
    return this.paymentMethod;
  }

  public setPaymentMethod(value: PaymentMethod): void {
    this.paymentMethod = value;
  }
}
